import { useEffect, useRef, useState } from 'react'
import { Dialog } from '@mui/material'
import { styled } from '@mui/system'
import { Column, GridApi } from 'ag-grid-community'
import './style.scss'
import { Props as RichTextFieldProps } from '../../common/richText'
import MultilineTextEditor from '../../../../../../../components/editors/multiline-text/MultilineTextEditor'
import CancelButton from '../../../../../../../components/buttons/CancelButton'
import { normalize } from '../../../../../../../../utils/multilineText'
import SaveButton from '../../../../../../../components/buttons/SaveButton'

// Styles
const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    maxWidth: '100% !important',
    height: '100%',
  },
})
const RichTextFieldWrapper = styled('div')({
  height: 'calc(100% - 54px)',
  width: 640,
  margin: 10,
  border: '2px solid #dddddd',
  borderRadius: 4,
})
const ButtonGroup = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 10,
})

interface OwnProps {
  parseValue?: (value: any) => any
  api: GridApi
  eventKey: string | null
  rowIndex: number
  column: Column
  field: string
}

type Props = OwnProps &
  RichTextFieldProps & { onValueChange: (value: any) => void }

const MultiLineTextCellEditor = (props: Props) => {
  const [value, setValue] = useState(() => normalize(props.value || ''))
  const [isOpen, setIsOpen] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current && isEditable()) {
      inputRef.current.focus()
      inputRef.current.selectionStart = inputRef.current.selectionEnd =
        inputRef.current.value.length
      inputRef.current.scrollTop = inputRef.current.scrollHeight
    }
    if (props.eventKey === 'Delete' || props.eventKey === 'Backspace') {
      props.api.clearFocusedCell()
      props.api.setFocusedCell(props.rowIndex, props.column)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- マウント時のみ実行。セルエディタの初期化処理
  }, [])

  const isEditable = () => {
    if (props.disabled) {
      return !props.disabled
    }
    const editable = props['colDef'].editable
    return typeof editable === 'function' ? editable(props) : editable
  }

  const handleClose = (
    _event: any,
    reason: 'escapeKeyDown' | 'backdropClick' | 'submit' | 'cancel'
  ) => {
    setIsOpen(false)
    props.api.stopEditing(
      ['escapeKeyDown', 'backdropClick', 'cancel'].includes(reason)
    )
  }

  const handleChangeText = (newValue: string) => {
    setValue(newValue)
    const parsed = props.parseValue ? props.parseValue(newValue) : newValue
    props.onValueChange(parsed)
  }

  return (
    <StyledDialog
      open={isOpen}
      onClose={(event, reason) => {
        handleClose(event, reason)
      }}
    >
      <RichTextFieldWrapper>
        <MultilineTextEditor
          dataUuid={props.data.uuid}
          externalId={props.field}
          value={value}
          setValue={handleChangeText}
          disableSbsMode={true}
        />
      </RichTextFieldWrapper>
      <ButtonGroup>
        <SaveButton onClick={e => handleClose(e, 'submit')} />
        <CancelButton onClick={e => handleClose(e, 'cancel')} />
      </ButtonGroup>
    </StyledDialog>
  )
}

export default MultiLineTextCellEditor
